module.exports = __webpack_public_path__ + "static/media/coatmin.4a6609dd.png";